import React, { useRef } from "react";
import img1 from "../../../assets/img/Home/card-cover.png";
import img2 from "../../../assets/img/Home/Rectangle 23.png";
import img3 from "../../../assets/img/Home/Rectangle 25.png";
import Slider from "react-slick";
import PlaceCard from "../../common/PlaceCard";
import { SampleNextArrow, SamplePrevArrow } from "../../shared/Arrow";
import { API_URL } from "../../../constants";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const SpecialPlace = ({ infoHome }) => {
  //special_residences
  const slider1 = useRef();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    rtl: false,
    arrow: false,
    centerMode: true,
    centerPadding: '6%',
    className: "carousel-padding",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
      
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
      
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const next = () => {
    slider1.current.slickNext();
  };
  const previous = () => {
    slider1.current.slickPrev();
  };
  return (
    <div className="container">
      <div className=" slider-con">
        {" "}<div className=" flex justify-between items-center">
          <div className="title--home">
            <h4 className="font-[700] text-[40px] text-[#292D32]">
              اقامتگاه های خاص{" "}
            </h4>
            <div className="text-[20px] mt-[10px] text-[#797D82] title--home--p">
              بهترین اقامتگاه ها را با مناسب ترین قیمت ها و امکانات رزرو کنید
            </div>
          </div>
          <div className="flex">
            <SampleNextArrow onClick={next} />
            <SamplePrevArrow onClick={previous} />
          </div>
        </div>
        <div className="Popularcity--slider mt-[40px]">
          {infoHome
            ? <Slider ref={slider => (slider1.current = slider)} {...settings}>
                {infoHome &&
                  infoHome.special_residences.map(i =>
                    <PlaceCard
                      img={`${i.thumbnail.path}`}
                      isfast={i.instant_reserve === 1 ? true : false}
                      rate={i.rating_value}
                      info={i.address}
                      title={i.title}
                      key={i.id}
                      cost={i.price}
                      tip={i.special_discount_in_24}
                      code={i.code}
                      slug={i.slug}
                      wishlist={i.wishlist}
                      id={i.id}
                      room={i.rooms_count}
                      city={i.city}
                      type={i.type}
                    />
                  )}
              </Slider>
            : <div className="container">
                <SkeletonTheme height={400} borderRadius={10}>
                  <div className="grid grid-cols-4 gap-[20px]">
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                  </div>
                </SkeletonTheme>
              </div>}
        </div>
      </div>
    </div>
  );
};

export default SpecialPlace;
